import { GoArrowUpRight } from "react-icons/go";

export default function Button({ children }) {
  return (
    <button className="bg-primary text-white px-6 py-3 mt-6 text-body rounded hover:opacity-90 transition flex items-center gap-2">
      {children}
      <GoArrowUpRight />
    </button>
  );
}